'use client';

import { useEffect, useState } from 'react';
import {
  BlurredButtonLink,
  START_ULTRAMETABOLIC_LINK,
  useAutoPlayVideoRef,
} from '../shared';
import { useForwardSearchParams } from '../../hooks/navigation/useForwardSearchParams';
import { getCompressedAssetUrl } from '../../lib/config/assetUrls';
import styles from './TopVideoSection.module.css';

const mobileVideoPath = getCompressedAssetUrl('/bumper_metabolic_mobile.mp4');
const desktopVideoPath = getCompressedAssetUrl('/bumper_metabolic.mp4');

export const TopVideoSection = () => {
  const [appeared, setAppeared] = useState(false);
  const videoRef = useAutoPlayVideoRef();
  const forwardSearchParams = useForwardSearchParams();

  useEffect(() => {
    setAppeared(true);

    const setDesktopVideoIfLargeScreen = () => {
      if (!videoRef.current) {
        return;
      }
      if (
        window.innerWidth > window.innerHeight &&
        (!videoRef.current.src ||
          !videoRef.current.src.endsWith(desktopVideoPath))
      ) {
        videoRef.current.src = desktopVideoPath;
        return;
      }
      if (
        window.innerWidth < window.innerHeight &&
        (!videoRef.current.src ||
          !videoRef.current.src.endsWith(mobileVideoPath))
      ) {
        videoRef.current.src = mobileVideoPath;
        return;
      }
    };

    window.addEventListener('resize', setDesktopVideoIfLargeScreen);
    setDesktopVideoIfLargeScreen();

    return () => {
      window.removeEventListener('resize', setDesktopVideoIfLargeScreen);
    };
  }, []);

  return (
    <div className={styles.container}>
      {}
      <video preload="none" loop autoPlay muted playsInline ref={videoRef}>
        <source src={mobileVideoPath} type="video/mp4" />
      </video>
      <div className={`${styles.content} u-grid`} data-appeared={appeared}>
        <div>
          <h1 className={styles.title}>Discover Metabolic Fitness</h1>
          <h2 className={styles.subTitle}>
            Improve your diet and exercise based on glucose biomarkers.
          </h2>

          <div className={styles.buttonContainer}>
            {/* <BlurredButtonLink
              href={forwardSearchParams(BOOK_CALL_LINK)}
              target="_blank"
              rel="noopener noreferrer"
              className="intercom_launcher_button"
            >
              Book a Call
            </BlurredButtonLink> */}
            <BlurredButtonLink
              href={forwardSearchParams(START_ULTRAMETABOLIC_LINK)}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.blurredButtonLink}
            >
              Order Now
            </BlurredButtonLink>
          </div>
        </div>
      </div>
    </div>
  );
};
